"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessResponse = exports.EmptyBody = exports.ListingId = exports.IntegerId = exports.Uuid = exports.FaIcon = exports.IntegerPathParam = exports.SerializableDate = void 0;
const zod_1 = require("zod");
exports.SerializableDate = zod_1.z
    .union([zod_1.z.string().datetime(), zod_1.z.date()])
    .transform((date) => (typeof date === 'string' ? new Date(date) : date));
// specifying positive() would be cleaner but Readme.io's validation complained about it
// https://github.com/anatine/zod-plugins/issues/170
exports.IntegerPathParam = zod_1.z.coerce.number().int().min(1);
exports.FaIcon = zod_1.z.custom((val) => /^fa-/.test(val));
exports.Uuid = zod_1.z.string().uuid();
exports.IntegerId = zod_1.z.number().int().nonnegative();
exports.ListingId = zod_1.z.union([exports.IntegerId, zod_1.z.string()]);
exports.EmptyBody = zod_1.z.object({}).optional();
exports.SuccessResponse = zod_1.z.object({
    success: zod_1.z.literal(true),
});
